import * as React from 'react'
import { SVGProps } from 'react'

const SvgUsdCoinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0h24v24H0z' />
    <path d='M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z' fill='#2775CA' />
    <path
      d='M15.3 13.9c0-1.75-1.05-2.35-3.15-2.6-1.5-.2-1.8-.6-1.8-1.3 0-.7.5-1.15 1.5-1.15.9 0 1.4.3 1.65 1.05.05.15.2.25.35.25h.8c.2 0 .35-.15.35-.35v-.05c-.2-1.1-1.1-1.95-2.25-2.05V6.5c0-.2-.15-.35-.4-.4h-.75c-.2 0-.35.15-.4.4v1.15c-1.5.2-2.45 1.2-2.45 2.45 0 1.65 1 2.3 3.1 2.55 1.4.25 1.85.55 1.85 1.35s-.7 1.35-1.65 1.35c-1.3 0-1.75-.55-1.9-1.3-.05-.2-.2-.3-.35-.3h-.85c-.2 0-.35.15-.35.35v.05c.2 1.25 1 2.15 2.65 2.4v1.2c0 .2.15.35.4.4h.75c.2 0 .35-.15.4-.4v-1.2c1.5-.25 2.5-1.3 2.5-2.65Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 9.55c-1.45 3.85.55 8.2 4.45 9.6.15.1.3.3.3.45v.7c0 .1 0 .15-.05.2-.05.2-.25.3-.45.2-2.8-.9-4.95-3.05-5.85-5.85-1.5-4.75 1.1-9.8 5.85-11.3.05-.05.15-.05.2-.05.2.05.3.2.3.4v.7c0 .25-.1.4-.3.5C7.4 5.85 5.75 7.45 5 9.55Zm9.3-5.8c.05-.2.25-.3.45-.2 2.75.9 4.95 3.05 5.85 5.9 1.5 4.75-1.1 9.8-5.85 11.3-.05.05-.15.05-.2.05-.2-.05-.3-.2-.3-.4v-.7c0-.25.1-.4.3-.5 2.05-.75 3.7-2.35 4.45-4.45 1.45-3.85-.55-8.2-4.45-9.6-.15-.1-.3-.3-.3-.5v-.7c0-.1 0-.15.05-.2Z'
      fill='#fff'
    />
  </svg>
)

export default SvgUsdCoinIcon
